import { render, staticRenderFns } from "./FilesForm.vue?vue&type=template&id=19b79d7c&scoped=true&"
import script from "./FilesForm.vue?vue&type=script&lang=js&"
export * from "./FilesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b79d7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19b79d7c')) {
      api.createRecord('19b79d7c', component.options)
    } else {
      api.reload('19b79d7c', component.options)
    }
    module.hot.accept("./FilesForm.vue?vue&type=template&id=19b79d7c&scoped=true&", function () {
      api.rerender('19b79d7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/forms/FilesForm.vue"
export default component.exports